import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ReduceMotionService } from "../../services/motion-control/reduce-motion.service";

@Directive({
  selector: '[appReduceMotion]',
  standalone: false
})
export class ReduceMotionDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private reduceMotionService: ReduceMotionService
  ) {
  }

  ngOnInit() {
    this.reduceMotionService.reduceMotion$
      .pipe(takeUntil(this.destroy$))
      .subscribe(reduceMotion => {
        if (reduceMotion) {
          this.el.nativeElement.classList.add('el-reduce-motion');
        } else {
          this.el.nativeElement.classList.remove('el-reduce-motion');
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
